import { Component, EventEmitter, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ErrorList } from '../../../controls/error-prompt/error-list.model';

@Component({
	selector: 'app-check-for-errors-message',
	templateUrl: './check-for-errors-message.component.html',
	styleUrls: ['./check-for-errors-message.component.css']
})
export class CheckForErrorsMessageComponent implements OnInit, OnDestroy {

	// Properties
	dialogBox: MatDialogRef<CheckForErrorsMessageComponent>;
	saveChoice: EventEmitter<number> = new EventEmitter<number>(); // 1 = save and continue, 0 = continue without save, -1 = cancel
	errors: ErrorList[] = [];
	preventSave = false;

	// Class Functions
	constructor(
		@Inject(MAT_DIALOG_DATA) public data: any
	) { }

	// Event Functions
	ngOnInit() {
		this.errors = this.data.errors;
		this.preventSave = this.data.preventSave;
	}

	ngOnDestroy() {
		this.saveChoice.emit(-1);
	}

	// Methods
	leavePage(choice: number) {
		this.saveChoice.emit(choice);
		this.dialogBox.close(choice);
	}
}
